module.exports = __webpack_public_path__ + "img/ico_light_5.f3048d41.png";